import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useState } from 'react';
import axiosInstance from '../../helpers/axios';
export default function CustomDropDown(props) {
  const {label, styles, options=[], id='', handleAutoCompleteChange, noOptionsText='No options', error=false, helperText='', disabled=false} = props
  const [internalValue, setInternalValue] = useState(props.value? props.value: "")
  const user=null

  const handleInputChange = async (e, value, reason) => {
    if (!value) {
      setInternalValue("");
      handleAutoCompleteChange(""); // Pass empty string to parent
      return;
    }
    setInternalValue(typeof value === "string" ? value : "");
    handleAutoCompleteChange(value); 
  
    const selectedItem = options.find(item => item.brandName === value);
    // ;
    // ;
    // ;
    if (selectedItem && selectedItem.brandName !=="UnListed") {
  
      const getprod = `/products/instituteId/active?instituteId=${selectedItem.id}`;
  
      try {
        const response = await axiosInstance.get(getprod, {
          headers: {
          },
        });
        const uniqueProducts = response?.data?.data?.reduce((acc, item) => {
          if (!acc.some((product) => product.tenure === item.tenure)) acc.push(item);
          return acc;
        }, []);
        const sortedTenures = uniqueProducts.length > 0
          ? uniqueProducts
              .map((item) => ({ label: (item.tenure).toString() }))
              .sort((a, b) => parseInt(a.label) - parseInt(b.label))
          : selectedItem.brandName === "Virohan Private Limited"
            ? [...Array.from({ length: 10 }, (_, i) => ({ label: (i + 6).toString() })), { label: "27" }]
            : [];
        handleAutoCompleteChange(value, sortedTenures);
  
      } catch (error) {
        console.error("API Error:", error);
      }
    }
  };
  //
  return (
    <Autocomplete
      disabled={disabled}
      value={typeof internalValue === "string" ? internalValue : ""}
      disablePortal
      noOptionsText={noOptionsText}
      options={options.map(item => id==='instituteName' ? item.brandName : item)}
      sx={{ width: '100%',
    maxWidth: 350, ...styles, "& .MuiPopper-root": {fontFamily:'Outfit'}}}
      size='small'
      onInputChange={handleInputChange}
      freeSolo
      renderInput={(params) =>
         <TextField {...params} label={label} 
         error={error}
         helperText={helperText}
         InputLabelProps={{
          sx: {fontFamily:'Outfit', bgcolor: "#fff8f4",fontWeight:'bold', borderRadius:'5px', fontSize:'14px', lineHeight:'20.25px', padding:'2px 8px 2px 8px', color:'#000'},
        }}
        
        sx={{width: '100%',
  maxWidth: 350, mb:2,
          "& label.Mui-focused": {
            color: "#000",
           
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#707C8B",
            },
            "&:hover fieldset": {
              borderColor: "#707C8B",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#707C8B",
            },
            '& .MuiInputBase-input': {
              fontFamily: 'Outfit', // This applies the fontFamily to the input text
            },
          },}}
        
          />}
    
    />
  );
}
